module.exports = __webpack_public_path__ + "img/img_intro_2_deco4.fccea0b7.gif";